import { injectGlobal } from 'styled-components';
import { appConfig } from './configureApp';

/* eslint no-unused-expressions: 0 */
injectGlobal`
  html,
  body {
    height: 100%;
    width: 100%;
  }

  body {
    font-family: '${appConfig.fontType}';
  }

  body.fontLoaded {
    font-family: '${appConfig.fontType}';
  }

  #app {
    background-color: #fff;
    // min-height: 100%;
    min-width: 100%;
  }

  p,
  label {
    font-family: '${appConfig.fontType}';
    line-height: 1.5em;
  }
  input[type=number]::-webkit-inner-spin-button, 
  input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0; 
  }

  .height-dues-protect {
    min-height: 500px;
  }

  .height-payment-details {
    min-height: 570px;
  }
`;



// WEBPACK FOOTER //
// ./app/global-styles.js